import React from 'react'
import Layout from '../components/common/layout/Index'

function LotSelection() {
 
    return (
        <Layout>
            <div className="step-1">
                <section className="lot-progress">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8 col-md-10 col-sm-12">
                                <h5>
                                    <span>
                                        STEP 1/4 <circle></circle> Registering for Live Auction Name
                                    </span>
                                    Registration type
                                    <em>How would you like to participate in this auction?</em>
                                </h5>
                                <ul>
                                    <li className="step"></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="lot-form">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8 col-md-10 col-sm-12">
                                <div className="radio-btns">
                                    <div className="radio-block">
                                        <div className="">
                                            <input name="" type="radio" className="css-radio" id="register" />
                                            <label htmlFor="register" className="css-labell"></label>
                                        </div>
                                        <h6>
                                            Register for myself
                                            <span>
                                                I will be the primary bidder and payer.
                                            </span>
                                        </h6>
                                    </div>
                                    <div className="radio-block">
                                        <div className="">
                                            <input name="" type="radio" className="css-radio" id="someone" />
                                            <label htmlFor="someone" className="css-labell"></label>
                                        </div>
                                        <h6>
                                            Register for someone else
                                            <span>
                                                Principal registration (Requires admin review).
                                            </span>
                                        </h6>
                                    </div>
                                </div>

                                <div className="bidder-btns mt-5">
                                    <button type="button" className='btn btn-sky back-btn'>
                                        <img src="/img/arrow-left.svg" alt="" className='mr4' />Back
                                    </button>
                                    <button type="button" className='btn btn-primary forward-btn' disabled>
                                        Next<img src="/img/arrow-right.svg" alt="" className='ml4' />
                                    </button>
                                </div>

                                <div className="register-for-someone">
                                    <h6>
                                        Please fill Principal details
                                    </h6>
                                    <form action="">
                                        <div className="row">
                                            <div className="col-lg-6 mb-3">
                                                <label htmlFor="" className='form-label'>
                                                    Principal’s first name*
                                                </label>
                                                <input type="text" className='form-control ' />
                                            </div>
                                            <div className="col-lg-6 mb-3">
                                                <label htmlFor="" className='form-label'>
                                                    Principal’s last name*
                                                </label>
                                                <input type="text" className='form-control ' />
                                            </div>
                                            <div className="col-lg-6 mb-3">
                                                <label htmlFor="" className='form-label'>
                                                    Principal’s ID type*
                                                </label>
                                                <input type="text" className='form-control ' />
                                            </div>
                                            <div className="col-lg-6 mb-3">
                                                <label htmlFor="" className='form-label'>
                                                    Principal’s ID number*
                                                </label>
                                                <input type="text" className='form-control ' />
                                            </div>
                                            <div className="col-lg-6 mb-3">
                                                <label htmlFor="" className='form-label'>
                                                    POA expiry date*
                                                </label>
                                                <input type="text" className='form-control ' />
                                            </div>
                                            <div className="col-lg-6 mb-3">
                                                <label htmlFor="" className='form-label'>
                                                    Principal’s phone*
                                                </label>
                                                <input type="text" className='form-control ' />
                                            </div>
                                            <div className="col-lg-6 mb-3">
                                                <label htmlFor="" className='form-label'>
                                                    Principal’s email*
                                                </label>
                                                <input type="text" className='form-control ' />
                                            </div>
                                        </div>
                                    </form>
                                </div>

                                <div className="register-for-someone">
                                    <h6>
                                        Documents
                                    </h6>

                                    <ul className="doc-list">
                                        <li>
                                            <div className="item">
                                                <div className="block">
                                                    <div className="icon">
                                                        <img src="/img/documents-icon.svg" alt="Upload Icon" />
                                                    </div>
                                                    <h6>
                                                        Principal’s ID document *
                                                        <span>
                                                            1 Image Required
                                                        </span>
                                                    </h6>
                                                </div>
                                                <div className="block">
                                                    <div className="doc-upload">
                                                        <button className="btn btn-white">
                                                            Upload <img src="/img/upload-icon.svg" alt="Upload Icon" className="ml4" />
                                                        </button>
                                                        <input type="file" name="myfile" accept=".pdf,.doc,.docx,image/*" />
                                                    </div>
                                                </div>
                                            </div>
                                            <ol className="pdf-list">
                                                <li>
                                                    <div className="icon">
                                                        <img src="/img/doc-icon.svg" alt="Document Icon" />
                                                    </div>
                                                    <h6>
                                                        <a href="#" target="_blank">1776137753.6658428_image_(6).png</a>
                                                    </h6>
                                                    <button className="delete-icon">
                                                        <img src="/img/delete-icon.svg" alt="Delete Icon" />
                                                    </button>
                                                </li>
                                            </ol>
                                        </li>

                                    </ul>
                                </div>

                                <div className="bidder-btns mt-5">
                                    <button type="button" className='btn btn-sky back-btn'>
                                        <img src="/img/arrow-left.svg" alt="" className='mr4' />Back
                                    </button>
                                    <button type="button" className='btn btn-primary forward-btn' disabled>
                                        Next<img src="/img/arrow-right.svg" alt="" className='ml4' />
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <div className="step-2">
                <section className="lot-progress">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8 col-md-10 col-sm-12">
                                <h5>
                                    <span>
                                        STEP 2/4 <circle></circle> Registering for Live Auction Name
                                    </span>
                                    Tell us what you’re interested in
                                    <em>This won’t affect your ability to bid. You can bid on any property during the auction.</em>
                                </h5>
                                <ul>
                                    <li className="step active"></li>
                                    <li className='step'></li>
                                    <li></li>
                                    <li></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="lot-form">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8 col-md-10 col-sm-12">

                                <div className="lot-prop scroll">
                                    <div className="block">
                                        <figure>
                                            <img className="slide-fixed" src="/img/trans-3x2.png" alt="" />
                                            <img className="slide-img" src="https://adresstorageaccount.blob.core.windows.net/adrescontainer/property_image/1773027730.6163924_1773027738.1703591.jpeg" alt="Property Pic" />
                                        </figure>

                                        <figcaption>
                                            <div className="top">
                                                <div className="id">AUC-5D33236AD</div>
                                                <h6>
                                                    Phular Residency
                                                    <span>
                                                        Al Rayyan Community, Abu Dhabi
                                                    </span>
                                                </h6>
                                            </div>
                                            <div className="types">
                                                <ul>
                                                    <li><img src="/img/bed-icon.svg" alt="" /> 4 Beds</li>
                                                    <li><img src="/img/bath-icon.svg" alt="" /> 4 Baths</li>
                                                    <li><img src="/img/ruler-icon.svg" alt="" /> 1,234 sqft</li>
                                                </ul>
                                            </div>
                                        </figcaption>

                                        <div className="price">
                                            <h6>
                                                ESTIMATE
                                                <span>
                                                    <em className='dirham'>D</em> 3.0M
                                                </span>
                                            </h6>
                                            <div className="check">
                                                <input type="checkbox" className='css-checkbox' id='price' />
                                                <label htmlFor="price" className='css-label'>&nbsp;</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="block active">
                                        <figure>
                                            <img className="slide-fixed" src="/img/trans-3x2.png" alt="" />
                                            <img className="slide-img" src="https://adresstorageaccount.blob.core.windows.net/adrescontainer/property_image/1773027730.6163924_1773027738.1703591.jpeg" alt="Property Pic" />
                                        </figure>

                                        <figcaption>
                                            <div className="top">
                                                <div className="id">AUC-5D33236AD</div>
                                                <h6>
                                                    Phular Residency
                                                    <span>
                                                        Al Rayyan Community, Abu Dhabi
                                                    </span>
                                                </h6>
                                            </div>
                                            <div className="types">
                                                <ul>
                                                    <li><img src="/img/bed-icon.svg" alt="" /> 4 Beds</li>
                                                    <li><img src="/img/bath-icon.svg" alt="" /> 4 Baths</li>
                                                    <li><img src="/img/ruler-icon.svg" alt="" /> 1,234 sqft</li>
                                                </ul>
                                            </div>
                                        </figcaption>

                                        <div className="price">
                                            <h6>
                                                ESTIMATE
                                                <span>
                                                    <em className='dirham'>D</em> 3.0M
                                                </span>
                                            </h6>
                                            <div className="check">
                                                <input type="checkbox" className='css-checkbox' id='price' checked />
                                                <label htmlFor="price" className='css-label'>&nbsp;</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="block">
                                        <figure>
                                            <img className="slide-fixed" src="/img/trans-3x2.png" alt="" />
                                            <img className="slide-img" src="https://adresstorageaccount.blob.core.windows.net/adrescontainer/property_image/1773027730.6163924_1773027738.1703591.jpeg" alt="Property Pic" />
                                        </figure>

                                        <figcaption>
                                            <div className="top">
                                                <div className="id">AUC-5D33236AD</div>
                                                <h6>
                                                    Phular Residency
                                                    <span>
                                                        Al Rayyan Community, Abu Dhabi
                                                    </span>
                                                </h6>
                                            </div>
                                            <div className="types">
                                                <ul>
                                                    <li><img src="/img/bed-icon.svg" alt="" /> 4 Beds</li>
                                                    <li><img src="/img/bath-icon.svg" alt="" /> 4 Baths</li>
                                                    <li><img src="/img/ruler-icon.svg" alt="" /> 1,234 sqft</li>
                                                </ul>
                                            </div>
                                        </figcaption>

                                        <div className="price">
                                            <h6>
                                                ESTIMATE
                                                <span>
                                                    <em className='dirham'>D</em> 3.0M
                                                </span>
                                            </h6>
                                            <div className="check">
                                                <input type="checkbox" className='css-checkbox' id='price' />
                                                <label htmlFor="price" className='css-label'>&nbsp;</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="block">
                                        <figure>
                                            <img className="slide-fixed" src="/img/trans-3x2.png" alt="" />
                                            <img className="slide-img" src="https://adresstorageaccount.blob.core.windows.net/adrescontainer/property_image/1773027730.6163924_1773027738.1703591.jpeg" alt="Property Pic" />
                                        </figure>

                                        <figcaption>
                                            <div className="top">
                                                <div className="id">AUC-5D33236AD</div>
                                                <h6>
                                                    Phular Residency
                                                    <span>
                                                        Al Rayyan Community, Abu Dhabi
                                                    </span>
                                                </h6>
                                            </div>
                                            <div className="types">
                                                <ul>
                                                    <li><img src="/img/bed-icon.svg" alt="" /> 4 Beds</li>
                                                    <li><img src="/img/bath-icon.svg" alt="" /> 4 Baths</li>
                                                    <li><img src="/img/ruler-icon.svg" alt="" /> 1,234 sqft</li>
                                                </ul>
                                            </div>
                                        </figcaption>

                                        <div className="price">
                                            <h6>
                                                ESTIMATE
                                                <span>
                                                    <em className='dirham'>D</em> 3.0M
                                                </span>
                                            </h6>
                                            <div className="check">
                                                <input type="checkbox" className='css-checkbox' id='price' />
                                                <label htmlFor="price" className='css-label'>&nbsp;</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="bidder-btns mt-4">
                                    <button type="button" className='btn btn-sky back-btn'>
                                        <img src="/img/arrow-left.svg" alt="" className='mr4' />Back
                                    </button>
                                    <a href="#" className='skip'>Skip this step</a>
                                    <button type="button" className='btn btn-primary forward-btn'>
                                        Save preferences<img src="/img/arrow-right.svg" alt="" className='ml4' />
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <div className="step-3">
                <section className="lot-progress">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8 col-md-10 col-sm-12">
                                <h5>
                                    <span>
                                        STEP 3/4 <circle></circle> Registering for Live Auction Name
                                    </span>
                                    Bidding Limit
                                    <em>Adjust your bidding limit to increase your bidding power.</em>
                                </h5>
                                <ul>
                                    <li className="step active"></li>
                                    <li className='step active'></li>
                                    <li className='step'></li>
                                    <li></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="lot-form">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8 col-md-10 col-sm-12">

                                <div className="register-for-someone">

                                    <div className="chosse-price">
                                        <div className="block">
                                            <div className="price-calculator-box">
                                                <button className='circle '>
                                                    <img src="/img/minus.svg" alt="" />
                                                </button>
                                                <h3>
                                                    <span>YOUR BIDDING LIMIT</span>
                                                    <em className='dirham'>D</em> 26,000
                                                </h3>
                                                <button className='circle '>
                                                    <img src="/img/plus-icon.svg" alt="" />
                                                </button>
                                            </div>
                                        </div>
                                        <div className="block">
                                            Minimum deposit required <strong><em className='dirham'>D</em> 26,000</strong>
                                        </div>
                                    </div>

                                    <div className="minimum-deposit">
                                        <div className="block">
                                            <h3>
                                                <span>
                                                    MINIMUM DEPOSIT
                                                </span>
                                                <em className='dirham'>D</em> 16,000
                                            </h3>
                                        </div>
                                        <div className="block">
                                            <h2>
                                                <span>
                                                    BID UP TO
                                                </span>
                                                <em className='dirham'>D</em> 1,600,000
                                            </h2>
                                        </div>
                                    </div>

                                    <div className="range-slider">
                                        Range Slider
                                    </div>

                                    <div className="bidding-rule">
                                        <h6>
                                            <img src="/img/info-icon.svg" alt="" /> Bidding Rules
                                        </h6>

                                        <ul>
                                            <li>
                                                You can bid on multiple properties, as long as your total active bids stay within your limit.
                                            </li>
                                            <li>
                                                Your deposit sets your bidding limit. The more you deposit, the more bidding power you have
                                            </li>
                                        </ul>
                                    </div>

                                </div>

                                <div className="bidder-btns mt-4">
                                    <button type="button" className='btn btn-sky back-btn'>
                                        <img src="/img/arrow-left.svg" alt="" className='mr4' />Back
                                    </button>

                                    <button type="button" className='btn btn-primary forward-btn'>
                                        Next<img src="/img/arrow-right.svg" alt="" className='ml4' />
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <div className="step-4">
                <section className="lot-progress">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8 col-md-10 col-sm-12">
                                <h5>
                                    <span>
                                        STEP 4/4 <circle></circle> Registering for Live Auction Name
                                    </span>
                                    Deposit & Bidding Limit
                                    <em>Adjust your deposit to increase your bidding power.</em>
                                </h5>
                                <ul>
                                    <li className="step active"></li>
                                    <li className='step active'></li>
                                    <li className='step active'></li>
                                    <li className='step'></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="lot-form">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8 col-md-10 col-sm-12">

                                <div className="register-for-someone">

                                    <div className="lot-payment">
                                        <div className="block">
                                            <h6>
                                                Deposit Hold Amount
                                                <span>
                                                    Fully refundable if you don't win
                                                </span>
                                            </h6>
                                            <div className="price">
                                                <h5>
                                                    <em className='dirham'>D</em> 26,000
                                                </h5>
                                                <div className="badge badge-success">Refundable</div>
                                            </div>
                                        </div>
                                        <div className="block">
                                            <h6>
                                                Payment Method
                                            </h6>
                                            <ul className='payment-mode'>
                                                <li>
                                                    <img src="/img/applepay.png" alt="" />
                                                </li>
                                                <li>
                                                    <img src="/img/googlepay.png" alt="" />
                                                </li>
                                                <li>
                                                    <img src="/img/visa-logo.png" alt="" />
                                                </li>
                                                <li>
                                                    <img src="/img/mastercard.png" alt="" />
                                                </li>
                                                <li className='amex'>
                                                    <img src="/img/amex.png" alt="" />
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                </div>

                                <div className="bidder-btns mt-4">
                                    <button type="button" className='btn btn-sky back-btn'>
                                        <img src="/img/arrow-left.svg" alt="" className='mr4' />Back
                                    </button>

                                    <button type="button" className='btn btn-primary forward-btn'>
                                        Proceed to Payment<img src="/img/arrow-right.svg" alt="" className='ml4' />
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <div className="lot-success">
                <p className='mb0'>
                    <img src="/img/check-L.svg" alt="Check icon" />
                </p>
                <h3>
                    Registration confirmed!
                </h3>
                <h6>
                    Be ready to place your bids the moment the live auction begins
                </h6>
                <div className="mt-3">
                    <button className='btn btn-primary'>Return to lot details</button>
                </div>
            </div>


            <div className="lot-success">
                <p className='mb0'>
                    <img src="/img/check-P.svg" alt="Check icon" />
                </p>
                <h3>
                    Registration Pending
                </h3>
                <h6>
                    Your principal registration is being reviewed by our admin team.
                </h6>

                <div className="pending-notify">
                    We will notify you via email once your registration has been approved. This typically takes 1-2 business hours.
                </div>

                <div className="mt-3">
                    <button className='btn btn-primary'>Return to lot details</button>
                </div>
            </div>

        </Layout>
    )
}

export default LotSelection